import listActions from 'src/modules/event/list/eventListActions';
import EventService from 'src/modules/event/eventService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENT_PROMOTE';

const eventPromoteActions = {
  PROMOTE_STARTED: `${prefix}_PROMOTE_STARTED`,
  PROMOTE_SUCCESS: `${prefix}_PROMOTE_SUCCESS`,
  PROMOTE_ERROR: `${prefix}_PROMOTE_ERROR`,

  PROMOTE_ALL_STARTED: `${prefix}_PROMOTE_ALL_STARTED`,
  PROMOTE_ALL_SUCCESS: `${prefix}_PROMOTE_ALL_SUCCESS`,
  PROMOTE_ALL_ERROR: `${prefix}_PROMOTE_ALL_ERROR`,

  doPromoteAll: (ids, targetVisibility) => async (dispatch) => {
    try {
      dispatch({
        type: eventPromoteActions.PROMOTE_ALL_STARTED,
      });

      const result = await EventService.promoteAll(ids, targetVisibility);

      dispatch({
        type: eventPromoteActions.PROMOTE_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.event.promoteAll.success', result.count),
      );

      getHistory().push('/event');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventPromoteActions.PROMOTE_ALL_ERROR,
      });
    }
  },
};

export default eventPromoteActions;
